import {Component} from '@angular/core';

@Component({
  selector: 'app-unauthorized',
  template: `
    <div class="row">
      <div class="col-xs-12">
        <div class="block-flat">
          <div class="header">
            <h3>Geen toegang</h3>
          </div>
          <div class="content">
            <p>U heeft geen machtiging voor dit onderdeel</p>
          </div>
        </div>
      </div>
    </div>
  `
})
export class UnauthorizedComponent {}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/unauthorized/unauthorized.component.ts